import request from "@/utils/requestToTrackingServer";
import requestMajestic from "@/utils/requestToMajesticServer";

function getUrlParameter(name, location) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function saveEvent(context, name) {
  const video_id = context.rootState.brandChannel.tape.video_id;
  const session_id = window.__ovmSID;

  if (typeof session_id === "undefined") {
    return false;
    // throw new Error("No SessionID error"); // pq não funciona?!??!
  }

  const event = {
    name,
    video_id,
    session_id,
    timestamp: new Date().toISOString(),
  };

  const user_id = context.rootState.brandChannel.tape.ovmConfig.env.user_id;
  if (user_id !== "undefined") {
    event.client_viewer_id = user_id;
  }

  if (navigator && navigator.userAgent) {
    event.user_agent = navigator.userAgent;
  }

  const uuid = getUrlParameter("id", context.rootState.brandChannel.tape.path);

  const videoIdsMajestic = [
    "63fce5ad110381000297230d",
    "62616c7a722e8e0004d6c3e4",
    "639a3fbb6c4a080004a16b67",
    "639a40f66c4a080004a16b72",
    "639a413d6c4a080004a16b7d",
    "63c5517a4654660004e36a7a",
    "68262743c4071500137ce710",
  ];

  if (videoIdsMajestic.includes(video_id)) {
    return requestMajestic({
      url: "/ts/events/save",
      method: "post",
      data: event,
      headers: {
        uuid: uuid, // Adiciona o UUID como valor do header 'X-Request-Id'
      },
    });
  } else {
    return request({
      url: "/events/save",
      method: "post",
      data: event,
    });
  }
}
